import { useFormikContext } from "formik";
import React, { useRef } from "react"
import { findField, updateField } from "@app/utils/form";

export const useBodyPartsObserver = (currentFieldsets) => {
    const { values } = useFormikContext();

	// patch field "physischegefaehrdungsanalyse_gefaehrdungsinfo_koerperteile" to element type "bodypartSelector"
	// save the initial body part options
	const bodypartsField = findField(currentFieldsets, "physischegefaehrdungsanalyse_gefaehrdungsinfo_koerperteile")
	let res = React.useMemo(() => {
		if (bodypartsField) {
			bodypartsField.elementType = "bodypartSelector"
			console.log('// save the initial body part options', bodypartsField.options);
			bodypartsField.defaultOptions ??= bodypartsField.options

			return {
				fieldsets: currentFieldsets
			}
		}
		return {
			fieldsets: currentFieldsets
		}
	}, [bodypartsField])


	// set bodypart options in case of set physicalValue
	const physicalValue = values.physischegefaehrdungsanalyse_gefaehrdungstyp_physische_gefaehrdung;
	const physicalField = findField(res.fieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_physische_gefaehrdung");
	res = React.useMemo(() => {
        if (physicalValue && physicalValue?.length > 0) {
            const riskTypeOption = physicalField.options.find(({ value }) => value === physicalValue);

            if (bodypartsField) {
                bodypartsField.options = [...(riskTypeOption?.koerperteile || [])];
            }
        }
		return {
			fieldsets: currentFieldsets,
		}
    }, [physicalValue, res.fieldsets]);


	// set bodypart options in case of set influencesValue
	const influencesValue = values.physischegefaehrdungsanalyse_gefaehrdungstyp_einflussamtaetigkeitsort;
	const influencesField = findField(res.fieldsets, "physischegefaehrdungsanalyse_gefaehrdungstyp_einflussamtaetigkeitsort")
	res = React.useMemo(() => {
		if (influencesValue && influencesValue?.length > 0) {
			const riskTypeOption = influencesField.options.find(({ value }) => value === influencesValue);

			if (bodypartsField) {
				bodypartsField.options = [...(riskTypeOption?.koerperteile || bodypartsField.defaultOptions)];
			}
		}
		return {
			fieldsets: currentFieldsets,
		}
	}, [influencesValue, res.fieldsets]);


	// set bodypart options in case of set hazardousValue
	const hazardousValue = values.physischegefaehrdungsanalyse_gefaehrdungstyp_gefahrenstoff;
	res = React.useMemo(() => {
		if (hazardousValue && hazardousValue?.length > 0) {
			if (bodypartsField) {
				bodypartsField.options = [...(bodypartsField.defaultOptions || [])];
			}
		}
		return {
			fieldsets: currentFieldsets,
		}
	}, [hazardousValue, res.fieldsets]);


	// set highlighted field
    // TODO set this flag in typo3
    res = React.useMemo(() => {
        const highlightedFieldset = res.fieldsets.find(
            ({ identifier }) => identifier === "physischegefaehrdungsanalyse_massnahmenausreichend",
        );
        if (highlightedFieldset) {
            highlightedFieldset.highlighted = true;
        }
		return {
			fieldsets: res.fieldsets,
		}
    }, []);

	return res;
};
